import React, { useState } from "react";
import {
  Stack,
  Typography,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Modal,
} from "@mui/material";
function AddMinor(props) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    birthDateDay: "",
    birthDateMonth: "",
    birthDateYear: "",
    relation: "",
  });
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 300,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };

  const handleChange = (e) => {
    console.log(e.target);
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  console.log(formData);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);
    const validateFormData = Object.values(formData).every(
      (value) =>
        value !== null &&
        value !== undefined &&
        value !== "" &&
        !(Array.isArray(value) && value.length === 0) &&
        !(
          typeof value === "object" &&
          value !== null &&
          Object.keys(value).length === 0
        )
    );
    console.log(validateFormData);
    if (validateFormData) {
      props.onValueChange(formData);
      setFormData({
        firstName: "",
        lastName: "",
        birthDateDay: "",
        birthDateMonth: "",
        birthDateYear: "",
        relation: "",
      });
      setOpen(false);
    }

    // props.onValueChange(formData);
  };

  const days = Array.from({ length: 31 }, (_, i) => i + 1);

  const years = Array.from(
    { length: 19 },
    (_, i) => new Date().getFullYear() - i
  );

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        sx={{ marginTop: "30px" }}
        onClick={handleOpen}
      >
        Add MINOR
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-title" variant="h6" component="h2">
            Add a Minor
          </Typography>
          <Stack
            direction="column"
            //   alignItems="end"
            spacing={2}
            padding={2}
            component="form"
            useFlexGap
            sx={{ flexWrap: "wrap" }}
            onSubmit={handleSubmit}
            maxWidth="600px"
          >
            <Box
              sx={{ paddingBottom: "5px", width: "100%", textAlign: "center" }}
            >
              <label> Minor Information</label>
            </Box>
            <TextField
              label="First name"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              required
              variant="standard"
              sx={{ width: "200px" }}
            />
            <TextField
              label="Last name"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              required
              variant="standard"
              sx={{ width: "200px" }}
            />

            <Stack direction="row" alignItems="end">
              <Box sx={{ paddingBottom: "5px" }}>
                <label>DOB: </label>
              </Box>

              <Stack
                direction="row"
                component="form"
                sx={{ width: "300px", marginLeft: "10px" }}
              >
                <FormControl variant="standard" sx={{ minWidth: 80 }}>
                  <InputLabel id="demo-simple-select-standard-label"></InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={formData.birthDateMonth}
                    onChange={handleChange}
                    label="MM"
                    required
                    sx={{ width: "60px" }}
                    name="birthDateMonth"
                    key={0}
                  >
                    {[
                      ["01", "Jan"],
                      ["02", "Feb"],
                      ["03", "Mar"],
                      ["04", "Apr"],
                      ["05", "May"],
                      ["06", "Jun"],
                      ["07", "Jul"],
                      ["08", "Aug"],
                      ["09", "Sept"],
                      ["10", "Oct"],
                      ["11", "Nov"],
                      ["12", "Dec"],
                    ].map((m) => (
                      <MenuItem key={m[0]} value={m[0]}>
                        {m[1]}
                      </MenuItem>
                    ))}
                    {/* <MenuItem value={"01"}>{"01"}</MenuItem>
                  <MenuItem value={"02"}>02</MenuItem>
                  <MenuItem value={"03"}>03</MenuItem> */}
                  </Select>
                </FormControl>

                <FormControl variant="standard" sx={{ minWidth: 80 }}>
                  <InputLabel id="demo-simple-select-standard-label"></InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={formData.birthDateDay}
                    onChange={handleChange}
                    label="DD"
                    name="birthDateDay"
                    required
                    sx={{ width: "60px" }}
                  >
                    {days.map((day) => (
                      <MenuItem key={day} value={day < 10 ? "0" + day : day}>
                        {day}
                      </MenuItem>
                    ))}

                    {/* <MenuItem value={"01"}>{"01"}</MenuItem>
                  <MenuItem value={"02"}>02</MenuItem>
                  <MenuItem value={"03"}>03</MenuItem> */}
                  </Select>
                </FormControl>

                <FormControl variant="standard" sx={{ minWidth: 120 }}>
                  <InputLabel id="demo-simple-select-standard-label"></InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={formData.birthDateYear}
                    onChange={handleChange}
                    required
                    label="YYYY"
                    name="birthDateYear"
                    sx={{ width: "70px" }}
                    key={1}
                  >
                    {years.map((year) => (
                      <MenuItem key={year} value={year}>
                        {year}
                      </MenuItem>
                    ))}

                    {/* <MenuItem value={"01"}>{"01"}</MenuItem>
                  <MenuItem value={"02"}>02</MenuItem>
                  <MenuItem value={"03"}>03</MenuItem> */}
                  </Select>
                </FormControl>
              </Stack>
            </Stack>
            <FormControl variant="standard" sx={{ minWidth: 120 }}>
              <InputLabel id="demo-simple-select-standard-label">
                Relation
              </InputLabel>

              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={formData.relation}
                onChange={handleChange}
                required
                label="Relation"
                name="relation"
                sx={{ width: "200px" }}
                key={2}
              >
                <MenuItem key={"Son"} value={"Son"}>
                  Son
                </MenuItem>
                <MenuItem key={"Daughter"} value={"Daughter"}>
                  Daughter
                </MenuItem>
                <MenuItem key={"Cousin"} value={"Cousin"}>
                  Cousin
                </MenuItem>
                <MenuItem key={"Other"} value={"Other"}>
                  Other
                </MenuItem>
              </Select>
            </FormControl>
          </Stack>

          <Button
            variant="outlined"
            // color="secondary"
            onClick={handleClose}
            sx={{ mt: 3 }}
          >
            Close
          </Button>

          <Button
            variant="contained"
            // color="secondary"
            onClick={handleSubmit}
            sx={{ mt: 3, ml: 6, width: "100px" }}
          >
            Add
          </Button>
        </Box>
      </Modal>
    </div>
  );
}

export default AddMinor;
